import axiosInstance from "./AxiosInstance";

export const getUsersAssesmentDraft = (userId) => {
  return axiosInstance
    .get(`/v1/draft/userAssesmentDraft/${userId}`)
    .then((res) => res.data)
    .catch((err) => Promise.reject(err));
};

// metadata only (no assessmentResponse), capped server-side — safe for users with huge draft counts
export const getUsersAssesmentDraftMinified = (userId) => {
  return axiosInstance
    .get(`/v1/draft/userAssesmentDraft/minified/${userId}`)
    .then((res) => res.data)
    .catch((err) => Promise.reject(err));
};

// templates a user is entitled to start (direct assignments + role-based access)
export const getUserAccessibleTemplates = (userId) => {
  return axiosInstance
    .get(`/v1/assignment/user/${userId}`)
    .then((res) => res.data)
    .catch((err) => Promise.reject(err));
};

export const getAssesmentDraftData = (assesmentId) => {
  return axiosInstance
    .get(`/v1/draft/${assesmentId}`)
    .then((res) => res.data)
    .catch((err) => Promise.reject(err));
};

export const getCompletedAssesmentDraft = (userId) => {
  return axiosInstance
    .get(`/v1/draft/completedDraft/${userId}`)
    .then((res) => res.data)
    .catch((err) => Promise.reject(err));
};

export const getDeletedAssesmentDraft = (userId) => {
  return axiosInstance
    .get(`/v1/draft/deleted/${userId}`)
    .then((res) => res.data)
    .catch((err) => Promise.reject(err));
};

export const getAssesmentDraftById = (assesmentId) => {
  return axiosInstance
    .get(`/v1/draft/${assesmentId}`)
    .then((res) => res.data)
    .catch((err) => Promise.reject(err));
};

export const SaveAssesmentDraft = (body) => {
  return axiosInstance
    .post(`/v1/draft`, body)
    .then((res) => res.data)
    .catch((err) => Promise.reject(err));
};

export const updateAssesmentDraft = (id, body) => {
  return axiosInstance
    .patch(`/v1/draft/${id}`, body)
    .then((res) => res.data)
    .catch((err) => Promise.reject(err));
};

export const DeleteAssesmentDraft = (assesmentId) => {
  return axiosInstance
    .delete(`/v1/draft/${assesmentId}`)
    .then((res) => res.data)
    .catch((err) => Promise.reject(err));
};
